import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
}));

export default function SaleManCommTable(props) {
  const { data, title } = props;
  const { t } = useTranslation(["forms"]);
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            style={{ backgroundColor: colors.green[300], color: "#fff" }}
          >
            <TableCell style={{ color: "#fff" }} align="center">
              {t("نوع الحركة")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("التاريخ")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("رقم الفاتورة")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("المندوب")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("قيمة الفاتورة بعد الخصم قبل الضريبة")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("نسبة العمولة")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("مبلغ العمولة")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("متوصط التكلفة ")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("مبلغ الضريبة")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("الربح")}
            </TableCell>
            <TableCell style={{ color: "#fff" }} align="center">
              {t("الصافي")}
            </TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.id}>
              <TableCell align="center">{row.col_trans_type}</TableCell>
              <TableCell align="center">{row.col_date}</TableCell>
              <TableCell align="center">{row.col_bill_no}</TableCell>
              <TableCell align="center">{row.col_sales_name}</TableCell>
              <TableCell align="center">{row.col_tot_net}</TableCell>
              <TableCell align="center">{row.col_commission}</TableCell>
              <TableCell align="center">{row.col_Amount_collected}</TableCell>
              <TableCell align="center">{row.col_CostAvg}</TableCell>
              <TableCell align="center">{row.col_amountOfVat}</TableCell>
              <TableCell align="center">{row.col_profit}</TableCell>
              <TableCell align="center">{row.col_qtys}</TableCell>
              <TableCell align="center">{}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
